// extracted by mini-css-extract-plugin
export var chevronIcon = "_4f-2";
export var teamName = "_4f-1";
export var teamSwitcherButton = "_4f-0";